// test828
(828 && 0);
